import Consts from "../commons/Consts";
import Fetcher from "../utils/Fetcher";
import Helpers from "../utils/Helpers";

const EventsService = {
    get(id) {
        return Fetcher.get(`${Consts.baseapi}/events${id ? '/' + id : ''}`);
    },

    getCategories() {
        return Fetcher.get(`${Consts.baseapi}/events/categories`);
    },

    save(data, id) {
        const func = id ? Fetcher.put : Fetcher.post;
        return func(`${Consts.baseapi}/events${id ? '/' + id : ''}`, data);
    },

    delete(id) {
        return Fetcher.delete(`${Consts.baseapi}/events/${id}`);
    },

    saveTicket(data, eventId, id) {
        const func = id ? Fetcher.put : Fetcher.post;
        return func(`${Consts.baseapi}/events/${eventId}/tickets${id ? '/' + id : ''}`, data);
    },

    deleteTicket(eventId, id) {
        return Fetcher.delete(`${Consts.baseapi}/events/${eventId}/tickets/${id}`);
    },

    searchEvent(params) {
        return Fetcher.get(`${Consts.baseapi}/search/events?${Helpers.objToUrlParams(params)}`);
    },

    getOrderInfos(token) {
        return Fetcher.get(`${Consts.baseapi}/invoices/${token}/check-status`);
    },

    getEventDashInfos(eventId) {
        return Fetcher.get(`${Consts.baseapi}/events/${eventId}/dash-infos`);
    }
};

export default EventsService;